export const ContentCard = ({ image, type, title, description, platform, comingSoon, testId }) => (
  <article
    className="wit-bento-cell group overflow-hidden flex flex-col p-0"
    data-testid={testId}
  >
    <div className="aspect-[4/3] overflow-hidden bg-roseMilk/40 relative">
      {comingSoon && (
        <span className="absolute top-3 left-3 z-10 wit-pill border-sandBeige bg-white/90 text-ink text-[0.65rem]">
          {comingSoon}
        </span>
      )}
      {image && (
        <img
          src={image}
          alt={title || ""}
          className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.01]"
        />
      )}
    </div>
    <div className="p-6 flex flex-col gap-3 flex-1">
      {type && (
        <span className="wit-pill border-sandBeige bg-ivory text-ink self-start">
          {type}
        </span>
      )}
      <h3 className="font-serif text-lg text-ink leading-snug">{title}</h3>
      <p className="text-sm text-warmGrey leading-relaxed flex-1">{description}</p>
      {platform && (
        <p className="wit-eyebrow text-warmGrey/80 mt-1">{platform}</p>
      )}
    </div>
  </article>
);

export default ContentCard;
